module.exports = __webpack_public_path__ + "img/cs3.3f19c154.png";